module.exports = __webpack_public_path__ + "img/GrassgreenTick.43a85009.png";